__turbopack_context__.v({
  "actions": "institutional-cta-module__i6i4uq__actions",
  "band": "institutional-cta-module__i6i4uq__band",
  "container": "institutional-cta-module__i6i4uq__container",
  "description": "institutional-cta-module__i6i4uq__description",
  "journey": "institutional-cta-module__i6i4uq__journey",
  "primary": "institutional-cta-module__i6i4uq__primary",
  "secondary": "institutional-cta-module__i6i4uq__secondary",
  "title": "institutional-cta-module__i6i4uq__title",
});
